<template>

<!--
    Technician Autocomplete Component

    @version 1.0
-->

<div class="input-group w-100 flex-nowrap border-0">

    <!-- technician auto complete -->
    <kt-autocomplete
        class="flex-grow-1"
        inputclass="form-control -rounded-end-0 form-control-sm"
        :options="list"
        rowvalue="TechnicianName"
        :rowkey="props.rowkey"
        :label="props.label"
        :placeholder="props.placeholder"
        @change="onChange"
        v-model="model"
        suffix-class="p-0"
    >
      
    <!-- drop down template -->
    <template #option="{ option }">
      <slot name="option" :option="option">
        <div class="dropdown-item autocomplete-option">
            {{ option.TechnicianName }}
        </div>
      </slot>
    </template>


    <!-- new technician button (if needed in the future) 
    <template #suffix>
        <button 
            @click="editTechnician()"
            class="btn btn-sm btn-outline-primary rounded-start-0"
        ><i class="fa fa-plus"></i>
        </button>
    </template>
    -->

    </kt-autocomplete>

</div>

</template>

<script setup>

import { ref, onMounted, computed } from "vue";
import { storeToRefs } from "pinia";
import { useTechStore } from "@/stores/TechStore";
import KtAutocomplete from "@/components/UI/KtAutocomplete.vue";

const props = defineProps(
{
    // sometimes we want the technician id ...
    rowkey: {
        type: String,
        default: "Id"
    },

    label: {
        type: String,
        default: "Technician"
    },

    inputClass: {
        type: String,
        default: ""
    },

    placeholder: {
        type: String,
        default: "Select a technician"
    },

    // Option to show only active technicians
    activeOnly: {
        type: Boolean,
        default: true
    },
});

const model = defineModel({
    type: String,
    default: ""
});

const emits = defineEmits(["change"]);
const techStore = useTechStore();

// Convert the Record<number, TechnicianModel> to an array for the autocomplete
// Filter by active status if activeOnly is true
const list = computed(() => {
    const techRecord = techStore.list;
    const allTechs = Object.values(techRecord);
    
    if (props.activeOnly) {
        return allTechs.filter(tech => tech.Active);
    }
    
    return allTechs;
});

const onChange = (value) =>
{
    emits("change", value);
}

const editTechnician = async () =>
{
    // Placeholder for future technician editing functionality
    console.log("Edit technician functionality not implemented yet");
};

onMounted(async () =>
{
    await techStore.reload();
});

</script>
